<template>
    <div class="card slightly_yellow_background">
      <card-header
        :title="$t('cms.campaign.CreatNotificationLabel')"
        :description="$t('cms.campaign.CreateNotificationText')"
        :infoConfig="$CONSTANTS.infoConfig.notification"
        :checked="isSavedNotification"
        :hasCheckMark="true"
      >
        <template #icon>
          <icon notificationNew xlarge />
        </template>
      </card-header>
      <form class="flex column" @submit.prevent="saveNotification">
        <input
          :value="title"
          @input="$emit('update:title', $event.target.value)"
          :placeholder="$t('cms.campaign.NotificationTitleInput')"
          name="title"
          class="grow box mb2"
          v-validate="'required'"
          style="text-align: left;"
        />

        <textarea
          :value="description"
          @input="$emit('update:description', $event.target.value)"
          name="description"
          v-validate="'required|max:160'"
          :placeholder="$t('cms.campaign.NotificationDescriptionInput')"
          class="pt2"
        ></textarea>

        <span class="length-count" :class="{invalid: description.length > 160}">
          {{description.length}}/160
        </span>

        <campaign-delay
          :value="delay"
          @input="$emit('update:delay', $event)"
        />

        <button
          type="submit"
          :disabled="!isDifferent"
          class="box primary block"
        >
          {{ $t('cms.campaign.saveButton') }}
        </button>
      </form>
    </div>
</template>

<script>
import CardHeader from '@/components/global/CardHeader.vue';
import CampaignDelay from '@/components/campaigns/components/CampaignDelay.vue';
import { objectIsDifferent } from '@/utils/difference';

export default {
  components: {
    CampaignDelay,
    CardHeader,
  },
  props: {
    title: { type: String },
    description: { type: String },
    delay: { type: String },
    isSavedNotification: { type: Boolean },
    isNew: { type: Boolean },
  },
  data() {
    return {
      savedData: {
        title: this.title,
        description: this.description,
        delay: this.delay,
      },
      saved: false,
    };
  },
  computed: {
    isDifferent() {
      return objectIsDifferent(
        this.savedData, {
          title: this.title,
          description: this.description,
          delay: this.delay,
        },
      );
    },
  },
  watch: {
    isDifferent: {
      immediate: true,
      handler() {
        if (this.isDifferent) {
          this.$emit('update:isSavedNotification', false);
        } else {
          this.title && this.description && this.$emit('update:isSavedNotification', true);
        }
      },
    },
  },
  methods: {
    async saveNotification() {
      await this.$validator.validate();
      const errors = await this.errors.all();
      if (errors.length > 0) {
        errors.forEach(this.showWarningNotification);
        return null;
      }
      this.savedData = { title: this.title, description: this.description, delay: this.delay };
      this.saved = true;
      this.$emit('update:isSavedNotification', false);
      !this.isNew && this.$emit('update-campaign');
      return null;
    },
  },
};
</script>
